module.exports = __webpack_public_path__ + "media/3_11.1d061003.wav";